import React, {FC, useEffect} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import MobxSelect from 'components/elements/fields/MobxSelect'
import MobxTextInput from 'components/elements/fields/MobxTextInput'
import {Col, Row} from 'components/elements/grid'
import {autoCalculatorOptions, maritalOptions, years} from 'models/W2/W2.configs'
import usStates from 'src/configs/usStates'
import {posthogTrack} from 'src/utils'
import {useW2Store} from 'src/utils/contexts/RootStore.context'

import s from './FieldsW2Information.module.scss'

const cx = cn.bind(s)

interface IFieldsInvoiceTaxProps {
	className?: string
}

const FieldsW2Information: FC<IFieldsInvoiceTaxProps> = ({className}) => {
	const w2Store = useW2Store()

	useEffect(() => {
		if (w2Store.isInformationStepFilled) {
			posthogTrack('[W2 FORM] Step 1 filled')
		}
	}, [w2Store.isInformationStepFilled])

	const onBlur = () => {
		w2Store.calculate()
	}

	/**
	 *  Set wages for all types of taxes.
	 *  We do it by onBlur function instead getters because the user should be able to change value by hand */
	const onIncomeBlur = () => {
		w2Store.setIncomes()
	}

	return (
		<fieldset className={cx(className)}>
			<Row>
				<Col xs={6} xl={{offset: 1, span: 5}}>
					<MobxSelect
						name="autoCalculator"
						placeholder="Select"
						label="Auto Calculator"
						store={w2Store.form}
						wrapperClassName={cx('field')}
						className={cx('editable')}
						options={autoCalculatorOptions}
						onBlur={onBlur}
					/>
				</Col>
				<Col xs={6} xl={5}>
					<MobxSelect
						name="year"
						label="What year"
						store={w2Store.form}
						options={years}
						wrapperClassName={cx('field')}
						className={cx('editable')}
						onBlur={onBlur}
						onChange={(e) => {
							const value = e.target.value
							w2Store.form.year = new Date(value)
						}}
						value={w2Store.form.year.getFullYear()}
					/>
				</Col>
			</Row>
			<Row>
				<Col xs={6} xl={{offset: 1, span: 5}}>
					<MobxSelect
						name="maritalStatus"
						label="Marital status"
						store={w2Store.form}
						options={maritalOptions}
						className={cx('editable')}
						wrapperClassName={cx('field')}
						onBlur={onBlur}
					/>
				</Col>
				<Col xs={6} xl={5}>
					<MobxTextInput
						name="dependentsAmount"
						label="Dependents amount"
						type="text"
						isFormatText
						shouldHandleOldValue
						isNumber
						store={w2Store.form}
						wrapperClassName={cx('field')}
						className={cx('editable')}
						onBlur={onBlur}
					/>
				</Col>
			</Row>
			<Row>
				<Col xs={12} xl={{offset: 1, span: 10}}>
					<MobxTextInput
						name="income"
						label="How much Did You Make Before Taxes Last Year?"
						required
						type="text"
						isFormatText
						shouldHandleOldValue
						isNumber
						store={w2Store.form}
						wrapperClassName={cx('field')}
						className={cx('editable')}
						onBlur={() => {
							onBlur()
							onIncomeBlur()
						}}
					/>
				</Col>
			</Row>
			<Row>
				<Col xs={12} xl={{offset: 1, span: 10}}>
					<MobxSelect
						name="state"
						data-testid="state"
						placeholder="Select state"
						label="What State Do You Work In?"
						required
						store={w2Store.form}
						options={usStates}
						wrapperClassName={cx('field')}
						className={cx('editable')}
						onBlur={onBlur}
					/>
				</Col>
			</Row>
		</fieldset>
	)
}

FieldsW2Information.displayName = 'FieldsW2Information'

export default observer(FieldsW2Information)
